import React from 'react'
import AboutMe from '../AboutMe/AboutMe'
import Contact from '../Contact/Contact'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import Projects from '../Projects/Projects'

const Home = () =>
{
    return (
        <>
            <Header />
            <AboutMe />
            <Projects />
            <Contact />
            <Footer />
        </>
    )
}

export default Home